

import {
    useCtx,
} from 'one-ui-provider';

export const Image_URL = (resolvedurl: any, httpurl: any) => {

    const {
        settings,
    } = useCtx();
    const { compatible } = settings;
    const { contact_center_type } = compatible;

    if (contact_center_type === 'wxcc') {
        return httpurl;
    } else {
        return resolvedurl;
    }


}